import { convertStartRegResponse, convertFinishRegRequest, convertStartAuthResponse, convertFinishAuthRequest } from '../../../../../lib/yubico-webauthn';


export class Controller {

	/** @ngInject */
	constructor($window, $state, HardTokenService, Alert, ConfirmModal) {
		this.HardTokenService = HardTokenService;
		this.Alert = Alert;
		this.$state = $state;
		this.$window = $window;
		this.ConfirmModal = ConfirmModal;
	}
	$onInit() {
		this.registrationEmail=angular.copy(this.regEmailData.emailAddress);
		this.unregisteredEmailProvided=!this.token.u2fRegistered && this.regEmailData.hasInvitationLink;
		this.unregisteredNoEmail = !this.token.u2fRegistered && !this.regEmailData.hasInvitationLink;
		this.regFlag= this.token.u2fRegistered? 'REGISTERED' : (this.unregisteredEmailProvided? 'PENDING' : 'NO_REGISTRATION');
		console.log(this); 
	}
	
	isEmailNotModified() {
		return !this.registrationEmail || (this.registrationEmail==this.regEmailData.emailAddress);
	}
	
	
	u2fRegistrationStart(reset) {
		if (reset) {
			this.HardTokenService
				.u2fResetRegistrationStart(this.token)
				.then((response)=>this.successReg(response))
				.catch((error)=>this.errorReg(error));
		} else {
			this.HardTokenService
				.u2fRegistrationStart(this.token)
				.then((response)=>this.successReg(response))
				.catch((error)=>this.errorReg(error));
		}

		 
	}
	
	/** @private */
	successReg(response) {
		var credOpts = convertStartRegResponse(response);
		this.$window.navigator.credentials.create(credOpts).then((credentials) => {
			var finishRegRequest = convertFinishRegRequest(credentials, response);
			this.u2fRegistrationFinish(finishRegRequest);
		}).catch((error) => console.log(error));
	}

	/** @private */
	errorReg() {
		this.Alert('danger', 'hard_tokens.edit.U2F_failed');
	}
	
	replaceData(data){
		angular.copy(data.hardToken, this.token);
		angular.copy(data.registrationData, this.regEmailData);
		this.$onInit();
	}
	
	u2fRegistrationFinish(data) {

		this.HardTokenService
			.u2fRegistrationFinish(this.token, data)
			.then((response) => {
				this.replaceData(response);
				//this.$state.reload('company.hard-token-management.edit.registration');
				const key = 'hard_tokens.edit.U2F_registration_successfully';
				this.Alert('success', key);
			}).catch((error) => this.Alert('danger', 'hard_tokens.edit.U2F_failed'));

	}
    
	u2fAuthenticationStart() {
		this.HardTokenService
			.u2fAuthenticationStart(this.token)
			.then((response) => {
				var credOpts = convertStartAuthResponse(response);
				this.$window.navigator.credentials.get(credOpts).then((credentials) => {
					var finishRegRequest = convertFinishAuthRequest(credentials, response);
					this.u2fAuthenticationFinish(finishRegRequest);
				});
			})
			.catch((error) => {
				console.log(error);
				const key = 'hard_tokens.edit.authentication_test_failed';
				this.Alert('danger', key);
			});

	}
	u2fAuthenticationFinish(authdata) {
		this.HardTokenService
			.u2fAuthenticationFinish(this.token, authdata)
			.then(() => {
				const key = 'hard_tokens.edit.authentication_test_successfully';
				this.Alert('success', key);
			})
			.catch((error) => {
				console.log(error);
				const key = 'hard_tokens.edit.authentication_test_failed';
				this.Alert('danger', key);
			});
	}
	
	sendReregistrationEmail(){
		this.isSending = true;
		this.HardTokenService.putRegEmailData(this.token,this.registrationEmail)
		.then((response) => {
			this.replaceData(response);
			const key = 'company.hard-token-management.edit.registration.send-email.success';
			this.Alert('success', key);
		})
		.catch((error) => {
			console.log(error);
			this.Alert('danger', error.message);
		})
		.finally(() => (this.isSending = false));
	}
	
	resendReregistrationEmail(){
		this.isSending = true;
		this.HardTokenService.resendRegEmail(this.token)
		.then((response) => {
			angular.copy(response, this.regEmailData);
			const key = 'company.hard-token-management.edit.registration.resend-email.success';
			this.Alert('success', key);
		})
		.catch((error) => {
			console.log(error);
			this.Alert('danger', error.message);
		}).finally(() => (this.isSending = false));
	}
	clearAndSend() {
        this.isSending = true;
        this.ConfirmModal({
            messageKey:'company.hard-token-management.edit.registration.confirm.text',
            titleKey:'company.hard-token-management.edit.registration.confirm.title'
        })
            .then(() =>
                this.sendReregistrationEmail()
            )
            .finally(() => (this.isSending = false));
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-edit/registration/hard-token-registration.controller.js